// Runtime-only UnoCSS configuration
// This file doesn't import from 'unocss' to avoid Node.js dependencies in the browser bundle
export const unoRuntimeConfig = {
  blocklist: [/^ag-/],
  theme: {
    colors: {
      border: '#e4e5e4',
      primary: '#28746E',
      'primary-dark': '#18544f',
      'primary-light': '#394D5B',
      'primary-translucid': '#E5F1EF',
      'primary-translucid-90': '#deedeb',
      'primary-contrast': '#ffffff',
      'primary-light-contrast': '#ffffff',
      secondary: '#0A2334',
      'secondary-contrast': '#ffffff',
      orange: '#EC7C1A',
      info: '#007CBA',
      'info-contrast': '#ffffff',
      success: '#008C6B',
      'success-contrast': '#FFFFFF',
      'success-light': '#7dd1be',
      warning: '#FF7A00',
      'warning-contrast': '#1D1D1D',
      error: '#CA0202',
      'error-contrast': '#ffffff',
      help: '#F68F09',
      'help-contrast': '#4D4D4E',
      'help-light': '#FDE8CE',
      'background-base': '#ffffff',
      'background-neutral': '#F1F4F5',
      'background-form': '#C6CAD2',
      'background-error': '#fee2e2',
      'background-info': '#c8e4f7',
      'background-help': '#FEF4E7',
      'background-inactive': '#D0D5DD',
      'background-contrast': 'rgba(0,0,0,.8)',
      'text-body': '#4D4D4E',
      'text-body2': '#8B889B',
      inactive: '#D0D5DD',
      'text-heading': '#413B5A',
      'text-contrast': '#ffffff',
      'text-error': '#7f1d1d',
      'border-base': '#e8e4e4',
      'border-input': '#C6CAD2',
      'background-pill': '#F0F0F0',
      'border-pill': '#D9D9D9',
      published: '#672E48',
      'syn-primary': '#21645F',
      'syn-secondary': '#BFD4D1',
      'syn-border': '#D0D5DD',
      'syn-selected-text': '#154541',
      'syn-selected': '#E5F1EF',
      'syn-unselected-text': '#475467',
      'syn-summary-totals-row': '#F7F8FB',
      'syn-title-text': '#1D2939',
      'syn-graph-text': '#98A2B3',
      'syn-overview-text': '#667085',
      'syn-graph-legend-text': '#183040',
      'syn-uptrend': '#0086C9',
      'syn-downtrend': '#EC7C1A',
      'syn-negative-bonds': '#002060',
      'button-text': '#344054',
      'syn-main-background': '#F7F8FB',
    },
    boxShadow: {
      paper: '2px 4px 23px rgba(0, 0, 0, 0.12)',
      steps: '0px 4px 15px rgba(0, 0, 0, 0.25)',
    },
    gridTemplateColumn: {
      'two-column-layout': '320px minmax(0, 1fr)',
    },
    width: {
      sidebar: '350px',
      'sidebar-sm': '256px',
      'sidebar-xs': '76px',
      main: 'calc(100% - 350px)',
      'main-sm': 'calc(100% - 256px)',
      'main-xs': 'calc(100% - 76px)',
    },
    minWidth: {
      sidebar: '350px',
      'sidebar-sm': '256px',
      'sidebar-xs': '76px',
      main: 'calc(100% - 350px)',
      'main-sm': 'calc(100% - 256px)',
      'main-xs': 'calc(100% - 76px)',
    },
  },
  shortcuts: {
    'entity-overview':
      'flex min-h-[275px] flex-col justify-between rounded-md bg-secondary p-6 text-secondary-contrast shadow-paper',
    'entity-overview-no-shadow':
      'flex min-h-[275px] flex-col justify-between rounded-md bg-secondary p-6 text-secondary-contrast',
    'two-column': 'xl:grid xl:grid-cols-two-column-layout xl:gap-4',
  },
};
